import React, { useEffect } from "react";

const Preloader = () => {
  useEffect(() => {
    document.body.classList.add("overflow-hidden");
    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, []);
  return (
    <div
      className="fixed w-full h-full bg-[#0000002a] z-50 top-0 left-0"
      style={{ display: "block" }}
    >
      <div className="absolute top-2/4 left-2/4 -translate-x-2/4 -translate-y-2/4 flex">
        {[1, 2, 3].map((item) => (
          <div
            key={item}
            className="spinner-bounce rounded-full inline-block origin-center h-[45px] w-[45px] will-change-transform bg-[var(--primary-color)] mx-1"
            style={{
              animation: `bounce 1.4s infinite ease-in-out ${item * 0.16}s`,
              transform: "translate3d(0,0,0)", // Force hardware acceleration
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default Preloader;
